var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTheme } from 'styled-components';
import formatDisplayDateWithFormat from 'syf-js-utilities/formats/formatDisplayDateWithFormat';
import Stack from '../../spacing/Stack';
import { FooterWrapper, LegendDate, StyledDisclaimer, StyledKey } from './subcomponents';
const AdditionalLegends = ({ legendKeys }) => (React.createElement(React.Fragment, null, legendKeys.map(({ dates, legendText, themeName }) => {
    const formattedDate = (dates === null || dates === void 0 ? void 0 : dates.length) && formatDisplayDateWithFormat(dates[0], 'MMM d y');
    return (React.createElement(LegendDate, { key: legendText, themeName: themeName, role: "img", "aria-label": `${formattedDate} is the ${legendText}` }, legendText));
})));
const DatePickerFooter = (_a) => {
    var { showLegend = true, bottomDisclaimerCopy, className, highlightDateThemeArr = [], selectedDate, selectedDateText = 'Selected payment date', topDisclaimerCopy } = _a, props = __rest(_a, ["showLegend", "bottomDisclaimerCopy", "className", "highlightDateThemeArr", "selectedDate", "selectedDateText", "topDisclaimerCopy"]);
    const theme = useTheme();
    const legendKeys = highlightDateThemeArr.filter(({ themeName }) => {
        var _a;
        return Boolean(((_a = theme.datepicker) === null || _a === void 0 ? void 0 : _a.legend) &&
            theme.datepicker.legend[themeName]);
    });
    const isSelectedDateValid = selectedDate && !Number.isNaN(selectedDate.getTime());
    const formattedSelectedDate = isSelectedDateValid && formatDisplayDateWithFormat(selectedDate, 'MMM d y');
    const TopDisclaimer = () => (React.createElement(React.Fragment, null,
        React.createElement(StyledDisclaimer, null, topDisclaimerCopy),
        React.createElement(Stack, { size: "large" })));
    const BottomDisclaimer = () => (React.createElement(StyledDisclaimer, null, bottomDisclaimerCopy));
    const LegendGroup = () => (React.createElement(StyledKey, null,
        React.createElement(LegendDate, { themeName: "selectedDate", role: "img", "aria-label": `${formattedSelectedDate} is the ${selectedDateText}` }, selectedDateText),
        React.createElement(AdditionalLegends, { legendKeys: legendKeys })));
    return (React.createElement(FooterWrapper, Object.assign({ className: className }, props),
        topDisclaimerCopy && React.createElement(TopDisclaimer, null),
        showLegend && React.createElement(LegendGroup, null),
        bottomDisclaimerCopy && React.createElement(BottomDisclaimer, null)));
};
export default DatePickerFooter;
